import params1 from 'src/assets/health/params1_img.png'
import params2 from 'src/assets/health/params2_img.png'
import params3 from 'src/assets/health/params3_img.png'

export const InquiryTerms = `
1.수집정보 ㈜데이터유니버스는 이용자의 원활한 고객상담 및 불만처리를 위하여 아래와 같은 정보를 수집합니다.
<br/><br/>
* 수집 정보 : 이름, 연락처, 이메일 주소, 고객의 문의/답변 내용에 포함된 정보 
<br/><br/>
2. 수집 및 이용 목적 수집된 정보는 고객문의 및 상담요청에 대하여 회신을 하거나, 상담을 위한 서비스 이용기록 조회를 목적으로 활용합니다. 
<br/><br/>
3. 보관 및 이용 기간 이용자의 정보는 문의 처리 이후 3년간 보관 후 파기됩니다.
`

export const HealthContents = [
  {
    path: '1',
    title: '함께 복용하면 좋은 영양제와 조심해야 할 조합은?',
    desc: '■ 함께 복용하면 좋은 영양제는?\n' +
            '1. 오메가3+ 비타민E : 함께 복용 시 흡수력 증가 \n' +
            '2. 코엔자임Q10 + 비타민E : 항산화 작용을 오래 유지\n' +
            '3. 코엠자임Q10 + 오메가 :  콜레스테롤 수치 저하\n' +
            '4. 철분과 + 비타민C :  피로 개선 및 빈혈 완화 효과\n' +
            '5. 마그네슘 + 칼슘 : 체내 흡수 증가 \n' +
            '\n' +
            '■ 조심해야 할 영양제 조합 \n' +
            '1. 칼슘+ 단백질 보충제 or 클로렐라 : 흡수력이 떨어지므로 주의\n' +
            '2. 베타카로틴 : 흡연자가 복용 시 폐암 발병률 상승\n' +
            '3. 루테인 :  일반인이 아닌 황반변성 환자에게 효과적 \n' +
            '4. 글루코사민 : 당뇨병 환자가 복용 시 혈당 수치를 높일 수 있으므로 주의 \n' +
            '\n' +
            '■ 영양제, 제대로 알고 복용하기\n' +
            '영양제는 건강을 증진시켜주지만, 잘못 복용하면 오히려 악영향을 끼칠 수 있기 때문에 나에게 어떤 영양제가 필요한지 의료진이나 약사와 충분히 상담 후 복용해야 합니다.   \n' +
            '(출처: 헬스인뉴스)\n' +
            '\n' +
            '※ 가족의 안부를 실시간으로 확인하고 싶다면? [휴대폰가족보호]로 소통하세요!\n' +
            'https://s.familycare.ai/10784b \n',
    imgSrc: params1
  },
  {
    path: '2',
    title: '만성두통, 효과적으로 예방하는 방법',
    desc: '■ 규칙적으로 유산소 운동하기!\n' +
            '1. 운동은 혈액순환, 신진대사를 활성화시키고 스트레스를 해소하는 데에 효과적\n' +
            '2. 편두통으로 고통을 받고 있다면 적어도 일주일에 3번, 1회 30분 정도 운동하기 \n' +
            '■ 정신 건강 보호하기!\n' +
            '1. 과도한 스트레스는 두통의 주범! 명상, 자수, 그림 그리기 등 정서적 이완 훈련하기\n' +
            '2. 수면부족, 수면과다는 두통의 원인이 될 수 있으므로 규칙적인 기상 및 취침 습관 가지기\n' +

            '■ 카페인 섭취 조절하기! \n' +
            '카페인 과다 섭취 시 신경이 과민화 되면서 두통의 원인이 되므로 섭취 횟수를 조절하기\n' +

            '■ 부족한 영양소를 채워 두통 예방하기!\n' +
            '미네랄, 마그네슘이 부족할 경우 두통 등의 증상을 유발할 수 있으므로 식단 관리 및 보충제를 복용하기 \n' +
            '(출처: 헬스인뉴스)\n' +

            '※ 가족의 안부를 실시간으로 확인하고 싶다면? [휴대폰가족보호]로 소통하세요!\n' +
            'https://play.google.com/store/apps/details?id=co.kr.datau.tesla_p',
    imgSrc: params2
  },
  {
    path: '3',
    title: '찰떡궁합인 줄 알았는데 같이 먹으면 좋지 않은 조합',
    desc: '■ 소고기 + 고구마\n' +
            '소고기와 고구마는 소화에 필요한 위산 농도가 달라 함께 섭취 시 위장에 부담이 되므로 주의하기\n' +
            '\n' +
            '■ 팥죽 + 설탕\n' +
            '팥에는 설탕을 파괴하는 사포닌 성분이 함유되어 있어, 팥죽을 먹을 때는 설탕 보다는 소금으로 감칠맛을 내기\n' +
            '\n' +
            '■ 토마토 + 설탕\n' +
            '토마토에 설탕을 넣게 되면 비타민이 파괴되기 때문에 토마토에 간을 하고 싶을 경우 소금을 뿌리기\n' +
            '\n' +
            '■ 게 + 감\n' +
            '게는 식중독균이 번식하기 쉽고, 감은 유해균의 배출을 막기 때문에 식중독에 걸릴 수 있어 주의하기\n' +
            '(출처: 헬스인뉴스)\n' +
            '\n' +
            '※ 가족의 안부를 실시간으로 확인하고 싶다면? [휴대폰가족보호]로 소통하세요!\n' +
            'https://s.familycare.ai/10784b',
    imgSrc: params3

  }
]
